import { render } from "./ItemExpert.vue?vue&type=template&id=1c5b1e8e&scoped=true"
import script from "./ItemExpert.vue?vue&type=script&lang=js"
export * from "./ItemExpert.vue?vue&type=script&lang=js"

import "./ItemExpert.vue?vue&type=style&index=0&id=1c5b1e8e&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5b1e8e"]])

export default __exports__